import type { ElementType, HTMLAttributes } from 'react'
import { cls } from './cls'

const GAP = { none: '', sm: 'mb-1', md: 'mb-2' }

/** Mostly a heading, sometimes the label on a form row — the three classes are
 *  the same either way, so the tag is a prop rather than a second component. */
type SectionTitleTag = 'h2' | 'h3' | 'h4' | 'h5' | 'label' | 'legend' | 'div' | 'span'

export interface SectionTitleProps extends HTMLAttributes<HTMLElement> {
  as?: SectionTitleTag
  gap?: keyof typeof GAP
  /** Only meaningful with as="label". */
  htmlFor?: string
}

/**
 * The small sentence-case heading that names a block of content — admin
 * panels, dashboard sections, form rows.
 *
 * No `display` is set: h2-h5 are already block, and the label call sites are
 * inline today. Adding `block` here would silently change their layout.
 */
export function SectionTitle({ as = 'h3', gap = 'md', className, ...rest }: SectionTitleProps) {
  const Tag = as as ElementType
  return (
    <Tag className={cls('text-sm font-medium text-ink-700', GAP[gap], className)} {...rest} />
  )
}
